import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoutes() {
  const user = useSelector((state) => state.auth.user);
  return !user ? <Navigate to="/guesswhofootball/login" /> : <Outlet />;
}
